import React, { useState, useRef } from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import "./advantage.css";
import htmlParser from "html-react-parser";



export default function MorganSection({ assistanceData, sectionRef, scrollToSection, loInformation }) {
  const [showSection, setShowSection] = useState(false);
  const handleClick = () => {
    setShowSection(true);
  };
 


  return (
    <>
      <div className="AttentionSection">
        <Container>
          <Row>
            <Col md={12} sm={12} lg={6} xl={6} >

              <p className="AttentionText">{htmlParser(assistanceData.attentiondetails)}</p>

            </Col>

            <Col md={12} sm={12} lg={6} xl={6} className="advantageSection">

              <p className="advantageText">{htmlParser(assistanceData.advantageheading)}</p>

              <ul className="advantageList">
                <li>
                  {htmlParser(assistanceData.advantagedetail1)}
                </li>
                <li>
                  {htmlParser(assistanceData.advantagedetail2)}
                </li>
                <li>
                  {htmlParser(assistanceData.advantagedetail3)}
                </li>
                <li>
                  {htmlParser(assistanceData.advantagedetail4)}
                </li>
                <li>
                  {htmlParser(assistanceData.advantagedetail5)}
                </li>
              </ul>
            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
}
